module.exports = __webpack_public_path__ + "static/media/demoform-hackle.fd5deffc.svg";